import script from "./MineralCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MineralCard.vue?vue&type=script&setup=true&lang=js"

import "./MineralCard.vue?vue&type=style&index=0&id=a9ff25c8&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9ff25c8"]])

export default __exports__